import React from 'react';
import { connect } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  withRouter,
} from 'react-router-dom';
import { ResourcesItem } from 'redux-and-the-rest';
import EducatorGate from '../../EducatorGate';
import { UserModel } from '../../models/userModel';
import { getUser } from '../../redux/reducers/userReducer';
import { ApplicationState } from '../../redux/types';

import { Routes } from '../../routes';
import { isEducator } from '../../utils/UserUtils';
import MyAccount from './MyAccount';
import Schools from './Schools';
import School from './School';
import Islands from './Islands';
import RegisteredUserGate from '../../RegisteredUserGate';
import DeleteIsland from '../island/manage-islands-wizard/DeleteIsland';
import Leaderboard from './Leaderboard';
import IslandGameScores from './IslandGameScores';
import AccountNav from './AccountNav';
import Island from './Island';

interface Props {
  user: ResourcesItem<UserModel>
}

const AccountScreen = ({ user }: Props): React.ReactElement => {
  const { Account } = Routes;
  const defaultAccountRoute = isEducator(user) ? Account.Schools.Index : Account.User.Edit;
  const location = useLocation();

  return (
    <div className="panel box">
      <AccountNav />

      <Switch location={location}>
        <Route path={Routes.Account.Student.GameScore}>
          <IslandGameScores />
        </Route>

        <Route path={Routes.Account.Student.Show}>
          <Island />
        </Route>

        <Route path={Routes.Account.Islands.Index}>
          <Islands />
        </Route>

        <Route path={Routes.Account.School.Edit}>
          <EducatorGate>
            <School />
          </EducatorGate>
        </Route>

        <Route exact path={Routes.Account.Schools.Index}>
          <EducatorGate>
            <Schools />
          </EducatorGate>
        </Route>

        <Route exact path={Routes.Account.Leaderboard.Index}>
          <EducatorGate>
            <Leaderboard />
          </EducatorGate>
        </Route>

        <Route path={Routes.Account.User.Edit}>
          <RegisteredUserGate>
            <MyAccount />
          </RegisteredUserGate>
        </Route>

        <Route path={Routes.Account.Index}>
          <Redirect to={defaultAccountRoute} />
        </Route>
      </Switch>

      <Switch location={location}>
        <Route
          exact
          path={Routes.Account.Student.Delete}
        >
          <DeleteIsland />
        </Route>

      </Switch>
    </div>
  );
};

const mapReduxStateToProps = ({ users }: ApplicationState) => ({
  user: getUser(users),
});

export default withRouter(connect(mapReduxStateToProps)(AccountScreen));
